import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const VENUE_LAYOUT_URL = "https://customer-assets.emergentagent.com/job_27178513-f6fb-45e5-994a-7b52c1854711/artifacts/r1r7sj64_argy%20table%20layout%20%282%29.png";

export const BookTableSection = ({ events }) => {
  const [selectedEvent, setSelectedEvent] = useState("");
  const activeEvents = events.filter(e => e.title);

  return (
    <section data-testid="book-table-section" className="py-10 lg:py-14 relative z-10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-4">
          <p className="text-[11px] font-medium tracking-[0.15em] text-white/60 uppercase mb-2">VIP Experience</p>
          <h2 className="font-syne text-2xl lg:text-3xl font-semibold text-white">Book Your Table</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-3 overflow-hidden rounded-md">
            <img
              src={VENUE_LAYOUT_URL}
              alt="Venue Table Layout"
              className="w-full h-auto object-contain"
            />
          </div>

          <div className="lg:col-span-2 panel-light rounded-md p-8 lg:p-10">
            <h3 className="font-syne text-xl font-semibold text-[#2D1810] mb-3">Reserve a VIP Table</h3>
            <p className="text-[#2D1810]/60 text-sm mb-8">
              Premium tables with dedicated service and the best views in the house.
            </p>

            {activeEvents.length > 0 && (
              <div className="mb-6">
                <label className="block text-xs font-medium text-[#2D1810]/50 uppercase tracking-wider mb-2">Select Event</label>
                <select
                  value={selectedEvent}
                  onChange={(e) => setSelectedEvent(e.target.value)}
                  data-testid="book-table-event-select"
                  className="input-on-orange w-full px-4 py-3 text-sm rounded-md"
                >
                  <option value="">Choose an event...</option>
                  {activeEvents.map((event) => (
                    <option key={event.id} value={event.slug}>
                      {event.title} — {event.date}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="flex flex-col sm:flex-row gap-3">
              {selectedEvent ? (
                <Link
                  to={`/events/${selectedEvent}`}
                  data-testid="book-table-btn"
                  className="btn-dark px-8 py-4 text-sm font-medium text-center rounded-md inline-flex items-center justify-center gap-2"
                >
                  Book Table <ArrowRight size={14} />
                </Link>
              ) : (
                <Link
                  to="/vip"
                  data-testid="book-table-btn"
                  className="btn-dark px-8 py-4 text-sm font-medium text-center rounded-md inline-flex items-center justify-center gap-2"
                >
                  View VIP Options <ArrowRight size={14} />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
